// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__p5Ek6","container":"main_container__iKXIm","number":"main_number__qpDPw","text":"main_text__G-Ml6","link":"main_link__KDyhD"};